import { Box, Typography } from '@mui/material'

export const ThanksPage = () => {
  return (
    <Box>
      <Box display="grid" justifyContent={"center"} marginY={5}>
        <Typography variant="h5" borderBottom={2} borderColor={"red"} color="red">受付完了</Typography>
      </Box>
      <Box display={'flex'} justifyContent={'center'} paddingTop={3}>
        <Box display={'grid'}>
          <Typography sx={{ whiteSpace: 'pre-line' }}>{
            `この度はお問合せいただきありがとうございます。

          お打合せをご希望の方には後日担当者よりご連絡いたします。

          また、資料送付をご希望の方は別途メールにて資料をお送りいたしますのでご確認ください。

          ご検討のほどよろしくお願い申し上げます。`
          }</Typography>
        </Box>
      </Box>
    </Box>
  )
}
